import { Component, NgZone, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../../services/data.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { NotificationService } from '../../../services/notification.service';
import { DownloadType, FileDownloadService } from '../../../services/file-download.service';
import { AutocompleteService } from '../../../services/autocomplete.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SieveOperator, SieveString } from '../../../helpers/sieve/sieveString.class';
import { PataviumRole } from '../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { WithSearchBarAndSieve } from '../../../helpers/base-classes/withSearcBarAndSieve.class';
import { IFileWithInfo } from '../../../models/request-and-responses/rest-api/interfaces/fileWithInfo';
import { IFlatUser } from '../../../models/request-and-responses/rest-api/interfaces/flatUser';
import { Subscription } from 'rxjs/Subscription';
import { LocalStorageService } from '../../../services/local-storage.service';
import { IUserToLinkTo } from '../../../helpers/userToLinkTo.interface';
import { ITableStorageInfo } from '../../../models/request-and-responses/rest-api/interfaces/tableStorageInfo';
import { SieveFilter, SieveSort } from '../../../helpers/sieve/sieve-filters-and-sorts';
import { LocalStorageKey } from '../../../models/frontend/local-storage.key';
import { SessionStorageService } from '../../../services/session-storage.service';
import { take } from 'rxjs/operators';
import { WebSocketMessageService } from '../../../services/web-socket/web-socket-message.service';
import { UserSessionInfo } from '../../../models/frontend/user.session-info';

export enum ActionDocument {
    Link = 0,
    Info = 1,
    Delete = 2,
    Create = 3
}

export class CheckedDocument {
    public idDocument: number;
    public checked = false;
    constructor(c: number, chk: boolean) {
        this.idDocument = c;
        this.checked = chk;
    }
}

@Component({
    selector: 'app-documentlist',
    templateUrl: './documentlist.component.html',
    styleUrls: ['./documentlist.component.css']
})
export class DocumentlistComponent extends WithSearchBarAndSieve implements OnInit, OnDestroy {
    ActionDocumentChoose = ActionDocument;
    DownloadTypeChoose = DownloadType;
    SieveSort = SieveSort;
    public documents: ITableStorageInfo[];
    public allUsersICanSee: IFlatUser[] = [];
    public selectedRecord: CheckedDocument[] = [];
    public checkAllRecords = false;
    public progressLink: number = null;
    public isInLoad = false;
    public thisFileSelected: IFileWithInfo;
    public modalRef: NgbModalRef;
    public selectConf: Object = {};
    public fileToUpload: File = null;
    public isUploadingFile = false;
    public selectedUser: String;

    public usersToLinkTo: IUserToLinkTo[] = [];
    public checkAll = false;
    protected canLinkOrUnlink = true;
    protected canDelete = true;
    isInitFinished = true;
    usernameFilter: string;
    documentSubscription: Subscription;
    documentFilter = SieveFilter.StorageFile.StorageFile;
    private sessionInfo: UserSessionInfo;

    constructor(
        protected toastr: ToastrService,
        protected dataService: DataService,
        protected modalService: NgbModal,
        protected modalConfig: NgbModalConfig,
        protected config: NgSelectConfig,
        protected zone: NgZone,
        protected notification: NotificationService,
        protected fileurl: FileDownloadService,
        protected ptautocomplete: AutocompleteService,
        protected ngxService: NgxUiLoaderService,
        protected localStorage: LocalStorageService,
        protected fileUrlService: FileDownloadService,
        protected webSocketMessageService: WebSocketMessageService
    ) {
        super([], [], ptautocomplete, ngxService, localStorage);
        this.sessionInfo = SessionStorageService.sessionInfo;
        this.localStorageKey = LocalStorageKey.DocumentPageConfig;
        this.selectConf = {
            notFoundText: 'Nessun risultato'
        };

        this.modalConfig.backdrop = 'static';
        this.modalConfig.keyboard = false;

        this.loadConfiguration();

        this.documentSubscription = new Subscription();
    }

    ngOnInit() {
        super.ngOnInit();
        this.initData();
    }

    ngOnDestroy(): void {
    }

    initData() {
        this.isInitFinished = false;
        //documents
        const sieveStringDocuments = new SieveString(this.sieveConf);
        this.dataService.getDocuments(sieveStringDocuments).subscribe(
            documents => {
                this.rows = documents.total;
                this.documents = documents.payload;
                //create selectedrecord.
                this.selectedRecord = new Array<CheckedDocument>();
                this.documents.forEach(pl => {
                    this.selectedRecord.push(new CheckedDocument(pl.id, false));
                });
                this.checkAllRecords = false;
                this.isInitFinished = true;
            },
            err => {}
        );
        //childsToLink
        const stringAgency = new SieveString();
        stringAgency.setPageSize(1000);
        const roleSearchFilter = this.getRoleToFilter();
        if (roleSearchFilter !== 0) {
            stringAgency.addFilters([
                {
                    key: SieveFilter.User.Role,
                    operator: SieveOperator.Equal,
                    value: roleSearchFilter
                },
                {
                    key: SieveFilter.User.IsDisabled,
                    operator: SieveOperator.Equal,
                    value: false
                }
            ]);
            this.dataService
                .getFlatUsers(stringAgency)
                .subscribe(response => (this.allUsersICanSee = response.payload));
        }
        this.usersToLinkTo = [];
    }

    uploadFile(files) {
        this.fileToUpload = files[0];
    }

    shouldUserBeHidden(user: IUserToLinkTo): boolean {
        const status = user.status != null ? user.status : false;
        const username = user.username || null;
        const textFilter =
            this.usernameFilter != null && this.usernameFilter.length > 0
                ? this.usernameFilter
                : null;
        return (
            status !== true &&
            textFilter != null &&
            username != null &&
            username.toLocaleLowerCase().includes(textFilter.toLocaleLowerCase()) === false
        );
    }
    private isUserVisible(user: IUserToLinkTo): boolean {
        return !this.shouldUserBeHidden(user);
    }
    setCheckAll() {
        const visibleUsers = this.usersToLinkTo.filter(user => this.isUserVisible(user));
        const areAllUsersSelected = visibleUsers.every(user => user.status === true);
        this.checkAll = visibleUsers.length > 0 && areAllUsersSelected === true;
    }

    toggleCheckAllVisibleUsers() {
        this.usersToLinkTo.map(utl => {
            if (this.isUserVisible(utl)) {
                utl.status = this.checkAll;
            }
        });
    }

    async confirmLink(id: number, type: any) {
        let listIds = new Array<number>();
        if (id === null) {
            listIds = this.selectedRecord.filter(r => r.checked).map(r => r.idDocument);
        } else {
            listIds.push(id);
        }
        const tolink = [],
            tounlink = [];
        this.usersToLinkTo.forEach(utl => {
            if (utl.status === true) {
                tolink.push({
                    idUser: utl.idUser,
                    idRole: utl.idRole
                });
            } else {
                tounlink.push({
                    idUser: utl.idUser,
                    idRole: utl.idRole
                });
            }
        });
        const totalCall = listIds.length * 2;
        let doneCall = 0;
        this.isInLoad = true;
        for (let i = 0; i < listIds.length; i++) {
            await this.dataService
                .associateDocument({
                    idFile: listIds[i],
                    userRole: tolink
                })
                .pipe(take(1))
                .toPromise();
            doneCall++;
            this.progressLink = Math.ceil((doneCall / totalCall) * 100);
        }
        for (let i = 0; i < listIds.length; i++) {
            await this.dataService
                .dissociateDocument({
                    idFile: listIds[i],
                    userRole: tounlink
                })
                .pipe(take(1))
                .toPromise();
            doneCall++;
            this.progressLink = Math.ceil((doneCall / totalCall) * 100);
        }

        this.initData();
        this.toastr.success('Configurazione salvata correttamente', 'Successo', {
            closeButton: true
        });
        this.closeModal();
        this.progressLink = null;
        this.isInLoad = false;
    }

    openModal(content: TemplateRef<any>, action: ActionDocument, documentSelected: ITableStorageInfo) {
        this.usernameFilter = null;
        this.thisFileSelected = null;
        this.selectedUser = '';
        this.usersToLinkTo = [];

        if (documentSelected !== null) {
            this.dataService.getUsersLinkedFile(documentSelected.id).subscribe(res => {
                this.thisFileSelected = res.payload[0];
                if (action === ActionDocument.Info) {
                    this.modalRef = this.modalService.open(content, {
                        centered: true,
                        size: 'lg',
                        windowClass: 'modal-xxl',
                        backdrop: 'static',
                        keyboard: false
                    });
                } else {
                    this.openAssoc(content);
                }
            });
        } else {
            this.openAssoc(content);
        }
    }

    private openAssoc(content: TemplateRef<any>): void {
        this.allUsersICanSee.forEach(agency => {
            const toBeChecked =
                this.thisFileSelected !== null &&
                this.thisFileSelected.userWithRole &&
                this.thisFileSelected.userWithRole.length &&
                this.thisFileSelected.userWithRole.some(uwr => {
                    return Number(uwr.idUser) === Number(agency.id);
                });
            this.usersToLinkTo.push({
                idUser: agency.id,
                idRole: agency.role,
                username: agency.username,
                status: toBeChecked
            });
        });
        this.setCheckAll();
        this.modalRef = this.modalService.open(content, {
            centered: true,
            size: 'lg',
            windowClass: 'modal-xxl'
        });
    }

    closeModal() {
        this.modalService.dismissAll();
        this.checkAll = false; //tmp fix
    }

    confirmUploadDocument() {
        this.isUploadingFile = true;
        if (this.fileToUpload !== null) {
            const file = this.fileToUpload;
            const description = null;
            const idOwner = SessionStorageService.sessionInfo.userId;
            const timestamped = false;
            const timestampInfos = null;
            this.dataService.uploadDocument(file, description, idOwner, timestampInfos, timestamped).subscribe(
                result => {
                    this.initData();
                    this.toastr.success('Documento caricato correttamente', 'Successo', {
                        closeButton: true
                    });
                    this.closeModal();
                    this.isUploadingFile = false;
                    this.fileToUpload = null;
                },
                err => {
                    this.isUploadingFile = false;
                    this.fileToUpload = null;
                }
            );
        }
    }

    async confirmRemoveDocument(id, type) {
        let listIds = new Array<number>();
        if (id === null) {
            listIds = this.selectedRecord.filter(r => r.checked).map(r => r.idDocument);
        } else {
            listIds.push(id);
        }
        for (let i = 0; i < listIds.length; i++) {
            await this.dataService
                .removeDocument(listIds[i])
                .pipe(take(1))
                .toPromise();
        }
        this.initData();
        this.toastr.success('Documento rimosso dal sistema', 'Successo', {
            closeButton: true
        });
        this.closeModal();
    }

    openDocumentPdf(fd, filename, typeDown: DownloadType = DownloadType.STREAM) {
        return this.fileUrlService.downloadAndOpenDocument(fd, filename, typeDown);
    }

    //Because you can see linked catalog only if you're authorized.
    getRoleToFilter(): PataviumRole {
        switch (SessionStorageService.sessionInfo.role) {
            case PataviumRole.Agency:
            case PataviumRole.AgencyOperator:
                return PataviumRole.Agent;
            case PataviumRole.BackOfficeOperator:
                return PataviumRole.Agency;
        }
        return 0;
    }

    selectAllRecord() {
        this.selectedRecord.forEach(o => {
            o.checked = this.checkAllRecords;
        });
    }

    get isVisibileLink() {
        return this.canLinkOrUnlink && this.selectedRecord.some(o => o.checked);
    }

    get isVisibleDelete() {
        return this.canDelete && this.selectedRecord.some(o => o.checked);
    }

    get selectedRecordsTrue() {
        return this.selectedRecord.filter(o => o.checked).length;
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/common/documentlist/documentlist.component.ts